/**
 * Ask the shell to move to a section, from anywhere below it.
 *
 * The shell owns section changes - the body attributes, the URL, the chart
 * resize on the way back to Explore - so a component that wants to go
 * somewhere asks rather than setting the atom and leaving the rest behind.
 */

import type { Section } from './store.ts';

export const OPEN_SECTION_EVENT = 'app-open-section';

export function openSection(host: EventTarget, section: Section): void {
  host.dispatchEvent(
    new CustomEvent<Section>(OPEN_SECTION_EVENT, { detail: section, bubbles: true, composed: true }),
  );
}
